import { useAuth } from '../providers/authentication-provider';
import {
    NoSeatsLeftInfoDialog,
    SubscriptionCancelledInfoDialog,
} from '../components/dialogs/subscription-issue-dialogs';
import { useState } from 'react';
import { useToast } from '@shadcn/ui/hooks/use-toast';
import { useChargebeeSubscription } from './account-management/hooks/use-chargebee-subscription';
import { SubscriptionStatus } from '@zaplify/subscriptions';
import { getZaplifySdk } from '@zaplify/sdk';
import { v4 as uuid4 } from 'uuid';

export const NoSeatPage = () => {
    const {
        authState: { user },
    } = useAuth();
    console.log('NoSeatPage rendered', user);

    if (!user) {
        return null;
    }

    const { toast } = useToast();
    const [loading, setLoading] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const { subscription, isLoadingSubscription, refetchSubscription } = useChargebeeSubscription();

    // User comes from cancelled subscription
    // User is invited to the org but have not yet been assigned a seat
    const isCancelled = subscription?.subscription?.status === SubscriptionStatus.CANCELLED;

    const createFreeSubscription = async () => {
        const profilesSdk = getZaplifySdk().profiles;

        await profilesSdk.billing.createFreeSubscription({ 'idempotency-key': uuid4() });
    };

    const handleReactivate = () => {
        setLoading(true);
        createFreeSubscription()
            .catch((error: any) => {
                toast({
                    title: 'Error',
                    description: error.message,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            {isCancelled ? (
                <SubscriptionCancelledInfoDialog
                    activeUsersCount={user?.userOrganization?.activeUsersCount || 0}
                    organizationName={user?.userOrganization?.name}
                    isLoading={loading}
                    handleReactivate={handleReactivate}
                    open={true}
                />
            ) : (
                <NoSeatsLeftInfoDialog
                    activeUsersCount={user?.userOrganization?.activeUsersCount || 0}
                    organizationName={user?.userOrganization?.name}
                    adminEmail={user?.userOrganization?.adminEmail}
                    open={true}
                />
            )}
        </>
    );
};

export default NoSeatPage;
